/** Match the server's project-write roles. Missing access never offers a write. */
export function canWriteProject(role: string | null | undefined): boolean {
  return role === 'owner' || role === 'collaborator' || role === 'team';
}
